import PropTypes from 'prop-types'
import { PlacemarkStyle } from './Placemark.styles'

const Placemark = ({ active = false }) => <div css={PlacemarkStyle(active)} />

Placemark.propTypes = {
  active: PropTypes.bool.isRequired,
}

export { Placemark }
